var React = require('react');

function IconCellPhone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.375 0.889648H4.625C2.13945 0.889648 0.125 2.9041 0.125 5.38965V32.3896C0.125 34.8752 2.13945 36.8896 4.625 36.8896H20.375C22.8605 36.8896 24.875 34.8752 24.875 32.3896V5.38965C24.875 2.9041 22.857 0.889648 20.375 0.889648ZM12.5 34.6396C11.252 34.6396 10.25 33.6377 10.25 32.3896C10.25 31.1416 11.252 30.1396 12.5 30.1396C13.748 30.1396 14.75 31.1416 14.75 32.3896C14.75 33.6377 13.7516 34.6396 12.5 34.6396ZM20.375 5.38965V27.8896H4.625V5.38965H20.375Z","fill":"#4D4540"}));
}

IconCellPhone.defaultProps = {"width":"25","height":"37","viewBox":"0 0 25 37","fill":"currentColor"};

module.exports = IconCellPhone;

IconCellPhone.default = IconCellPhone;
